import React from 'react';
import { FiX, FiPhone, FiMail, FiMapPin } from 'react-icons/fi';

export default function ContactModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    const contactDetails = [
        {
            icon: <FiPhone className="text-blue-600" size={24} />,
            label: "Phone",
            value: "+94 71 930 4566",
            subValue: "Coordinator - Mr. Manoj  "
        },
        {
            icon: <FiMail className="text-blue-600" size={24} />,
            label: "Email",
            value: "support@sudeshmaths.com",
            subValue: "General Inquiries",
        },

    ];

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm">
            <div className="bg-white rounded-3xl w-full max-w-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
                <div className="px-8 py-6 bg-blue-600 text-white flex justify-between items-center">
                    <div>
                        <h3 className="text-xl font-bold">Academic Support</h3>
                        <p className="text-blue-100 text-sm">Get in touch with us for any help</p>
                    </div>
                    <button onClick={onClose} className="bg-white/20 hover:bg-white/30 p-2 rounded-xl transition-colors">
                        <FiX size={24} />
                    </button>
                </div>

                <div className="p-8 space-y-6">
                    {contactDetails.map((detail, idx) => (
                        <div key={idx} className="flex items-start gap-4 p-4 rounded-2xl bg-gray-50 border border-gray-100 hover:border-blue-200 transition-colors">
                            <div className="mt-1 bg-white p-3 rounded-xl shadow-sm">
                                {detail.icon}
                            </div>
                            <div>
                                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">{detail.label}</p>
                                <p className="text-base font-bold text-gray-900 leading-tight">{detail.value}</p>
                                <p className="text-sm text-gray-500 mt-1">{detail.subValue}</p>
                            </div>
                        </div>
                    ))}

                    <div className="pt-4">
                        <button
                            onClick={onClose}
                            className="w-full py-4 bg-gray-100 text-gray-600 font-bold rounded-2xl hover:bg-gray-200 transition-colors text-sm uppercase tracking-widest"
                        >
                            Back to Schedules
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
